import { ValidationProps } from 'ui/common/validation/types';
import { validateComplexValue, validateIfNotEqual } from 'app/area/codetable/item/screen-renderer/screen-validate/helpers';
import { ValidationData } from 'app/area/codetable/item/validation/validate';
import { ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';

export const validateUnitOfMeasureConversionType = (validationData: ValidationData): { [key: string]: ValidationProps } => {
  const { codeItem, translation } = validationData;
  const uomTypeFromValidation = validateComplexValue(ScreenPicker.uomTypeFrom, codeItem, translation);
  const uomTypeToValidation = validateComplexValue(ScreenPicker.uomTypeTo, codeItem, translation);
  const areTypesEqual = !uomTypeFromValidation.uomTypeFrom && !uomTypeToValidation.uomTypeTo &&
    validateIfNotEqual(ScreenPicker.uomTypeFrom, ScreenPicker.uomTypeTo, codeItem, translation.types_cannot_be_equal);

  if (areTypesEqual) {
    return areTypesEqual;
  }

  return {
    ...uomTypeFromValidation,
    ...uomTypeToValidation
  };
};
